import { render, staticRenderFns } from "./HomePortofolio.vue?vue&type=template&id=688a1a99&lang=pug&"
import script from "./HomePortofolio.vue?vue&type=script&lang=js&"
export * from "./HomePortofolio.vue?vue&type=script&lang=js&"
import style0 from "./HomePortofolio.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports